export const SM_SIZE = 320;
export const MD_SIZE = 667;
export const LG_SIZE = 960;
export const XL_SIZE = 1280;
export const _2XL_SIZE = 1480;
export const XXL_SIZE = 1820;

export const MAX_WIDTH_IPAD = 1300;
